var translationSupportedLanguages = {
    en: 'English',
    nl: 'Dutch',
    de: 'German'
};
export default translationSupportedLanguages;
